import useUser from '@/hooks/useUser';
import { NarrativeMiniValuatorCompanySearch } from './NarrativeMiniValuatorCompanySearch';
import { NarrativeMiniValuatorRecentlyViewedCompanies } from './NarrativeMiniValuatorRecentlyViewedCompanies';
import { NarrativeMiniValuatorTrendingCompanies } from './NarrativeMiniValuatorTrendingCompanies';
import { Heading } from '@simplywallst/ui-core/next';
import { headingIncrement, type HeadingElements } from '@/utilities/heading';

type Props = {
  onCompanySelect: (canonicalUrl: string) => void;
  titleAs: HeadingElements;
};

export const NarrativeMiniValuatorCompanySelect = ({
  onCompanySelect,
  titleAs,
}: Props) => {
  const {
    data: { loggedIn },
  } = useUser();
  return (
    <div className="grid gap-x1 py-x2">
      <div className="grid gap-x1 px-x2">
        <Heading as={titleAs} className="m-0 text-xs font-normal">
          Value any company in seconds
        </Heading>
        <div className="relative h-11">
          <NarrativeMiniValuatorCompanySearch
            onCompanySelect={onCompanySelect}
          />
        </div>
      </div>

      {loggedIn && (
        <>
          <Heading
            as={headingIncrement(titleAs)}
            className="m-0 mt-x1 px-x2 text-xs font-normal"
          >
            Recently viewed companies
          </Heading>
          <div className="px-x1">
            <NarrativeMiniValuatorRecentlyViewedCompanies
              onCompanySelect={onCompanySelect}
            />
          </div>
        </>
      )}
      <Heading
        as={headingIncrement(titleAs)}
        className="m-0 mt-x1 px-x2 text-xs font-normal"
      >
        Popular companies
      </Heading>
      <div className="px-x1">
        <NarrativeMiniValuatorTrendingCompanies
          onCompanySelect={onCompanySelect}
        />
      </div>
    </div>
  );
};
